module.exports = __webpack_public_path__ + "static/media/Logo-Banorte.a87b3f9e.svg";